import React from 'react';
import 'twin.macro';
import { GET_TIKTOK_LOCATION_COUNTRIES } from 'graphql/locations/queries';
import { useQuery } from 'hooks/sympl-query';
import { AdChannel } from 'types/adTypes';
import { TargetingLocation } from 'types/geolocationTypes';
import {
  getTikTokLocationWarning,
  TIKTOK_LOCATION_CHECK_UNAVAILABLE,
} from 'utils/channelRestrictions';

interface ChannelLocationWarningProps {
  channels: AdChannel[];
  locations: TargetingLocation[];
}

const ChannelLocationWarning: React.FC<ChannelLocationWarningProps> = ({
  channels,
  locations,
}) => {
  const shouldCheck =
    channels.includes(AdChannel.TIKTOK) && locations.length > 0;
  const { data, loading, error } = useQuery<{
    tiktokLocationCountries: { country_codes: string[] };
  }>(GET_TIKTOK_LOCATION_COUNTRIES, {
    skip: !shouldCheck,
    // Recheck when entering either view, including after the daily catalogue refresh.
    fetchPolicy: 'network-only',
  });

  if (!shouldCheck || loading) return null;

  const countryCodes = data?.tiktokLocationCountries?.country_codes;
  const message =
    error || !countryCodes
      ? TIKTOK_LOCATION_CHECK_UNAVAILABLE
      : getTikTokLocationWarning(locations, countryCodes);

  if (!message) return null;

  return (
    <div
      role="alert"
      tw="text-sm text-orange-700 p-4 bg-orange-50 mt-2 mb-4 rounded-xl"
    >
      {message}
    </div>
  );
};

export default ChannelLocationWarning;
